import {useEffect, useState} from "react";
import CustomIcon from "../common/CustomIcon";
import {Modal, Row} from "antd";
import i18next from "i18next";
import iconfont from "../../assets/font/appfonts/iconfont.json";

const iconBgColors = ["flowfont-blue", "flowfont-green", "flowfont-yellow", "flowfont-red"];
export const SettingIconModal = (props) => {
  const {visible, onCancel, onConfirm} = props;
  const [icons, setIcons] = useState([]);
  const [currentSelectedIcon, setCurrentSelectedIcon] = useState("");
  const [iconValue] = useState("appfont icon-tongji flowfont-blue");
  const [iconClass, setIconClass] = useState("");

  useEffect(() => {
    // const arr = [];
    // for (let index = 0; index < 55; index++) {
    //   arr.push({
    //     iconName: `icon-group-${index + 1}`,
    //     icongBgColor: `${iconColors[index % 5]}`,
    //   });

    //   setIcons(arr);
    // }
    const iconGroup = iconfont.glyphs.map(
      (v, i) => ({
        iconName: `${v.font_class}`,
        iconClass: `${iconfont.font_family} ${iconfont.css_prefix_text}${v.font_class} ${
          iconBgColors[i % 4]
        }`,
      })
    );
    setIcons(iconGroup);
    setCurrentSelectedIcon(iconValue);
  }, []);
  return <Row>
    <Modal
      maskClosable={false}
      destroyOnClose={true}
      title={i18next.t("选择图标")}
      visible={visible}
      okText={i18next.t("general:Confirm")}
      cancelText={i18next.t("general:Cancel")}
      onCancel={onCancel}
      onOk={() => onConfirm(currentSelectedIcon, iconClass)}
      width={360}
    >
      <Row type="flex" justify="start" style={{height: 400, overflow: "auto"}}>
        {
          icons.map((item, index) =>
            <CustomIcon
              key={index}
              iconName={item.iconName}
              iconClass={item.iconClass}
              actived={item.iconName === currentSelectedIcon}
              onSelect={(iconName, iconClassStr) => {
                setCurrentSelectedIcon(iconName);
                setIconClass(iconClassStr);
              }}
            />)
        }

      </Row>
    </Modal>
  </Row>;
};

export default SettingIconModal;
